/**
 * ドラゴンのマーク（ロゴ）。Claude Design の `drawgon 公開サイト` のヘッダーと同じ形。
 *
 * アプリの `dragon-mark.svg`（アバターを決めていない人の丸）と同じ線に、鼻の点を 1 つ足してある。
 * 色は `currentColor`（使う側が `text-ink` を付ける。生の hex を書かない）。
 * 飾りなので読み上げない（隣にワードマークがある）。
 */
export function DragonMark({ className }: { className?: string }) {
  return (
    <svg viewBox="6 2 110 114" className={className} aria-hidden="true" focusable="false">
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="8"
        strokeLinejoin="round"
        strokeLinecap="round"
      >
        <path d="M52 30 L44 8 L68 24 Z" />
        <path d="M88 30 L98 8 L102 34 Z" />
        <path d="M78 26 C52 26 32 44 28 66 C20 68 14 78 18 88 C22 98 34 102 44 100 C54 106 62 108 72 107 C96 103 108 91 106 73 C104 49 98 26 78 26 Z" />
        <path d="M30 90 C40 97 50 95 56 88" />
      </g>
      <circle cx="60" cy="66" r="5" fill="currentColor" />
      <circle cx="26" cy="78" r="2.6" fill="currentColor" />
    </svg>
  );
}
